export type Purchase = {
  firstName: string
  lastName: string
  city: string
  product: string
  time: string
}

export const purchases: Purchase[] = [
  { firstName: 'María', lastName: 'Gutiérrez', city: 'Santiago', product: 'el pack completo', time: 'hace 2 minutos' },
  { firstName: 'Lucía', lastName: 'Fernández', city: 'Buenos Aires', product: 'el pack completo', time: 'hace 4 minutos' },
  { firstName: 'Carmen', lastName: 'Ramírez', city: 'Madrid', product: 'el pack completo', time: 'hace 6 minutos' },
  { firstName: 'Valeria', lastName: 'Morales', city: 'Ciudad de México', product: 'el pack completo', time: 'hace 8 minutos' },
  { firstName: 'Andrés', lastName: 'Peralta', city: 'Bogotá', product: 'el pack completo', time: 'hace 11 minutos' },
  { firstName: 'Sofía', lastName: 'Torres', city: 'Lima', product: 'el pack completo', time: 'hace 13 minutos' },
  { firstName: 'Paula', lastName: 'Castro', city: 'Montevideo', product: 'el pack completo', time: 'hace 15 minutos' },
  { firstName: 'Rosa', lastName: 'Herrera', city: 'Ciudad de Guatemala', product: 'el pack completo', time: 'hace 17 minutos' },
  { firstName: 'Daniela', lastName: 'Salazar', city: 'Quito', product: 'el pack completo', time: 'hace 19 minutos' },
  { firstName: 'Javier', lastName: 'Aguirre', city: 'Barcelona', product: 'el pack completo', time: 'hace 21 minutos' },
  { firstName: 'Natalia', lastName: 'Giménez', city: 'Córdoba', product: 'el pack completo', time: 'hace 24 minutos' },
  { firstName: 'Gabriela', lastName: 'Vidal', city: 'San José', product: 'el pack completo', time: 'hace 27 minutos' },
]
